<!-- @format -->

<ng-container *transloco="let t">
  <dt>
    {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ADDITIONAL_INFO") }}
    <fudis-language-badge-group [translatedLanguages]="providedLanguages" (handleClick)="changeLanguageBadgeContent($event)">
    </fudis-language-badge-group>
  </dt>
  @if (selectedDescriptionLanguage) {
    <dd [attr.lang]="(data | localizedStringWithoutFallback: selectedDescriptionLanguage) && selectedDescriptionLanguage">{{
      (data | localizedStringWithoutFallback: selectedDescriptionLanguage) || "-"
    }}</dd>
  } @else {
    <dd>{{ "-" }}</dd>
  }
</ng-container>
